module.exports = __webpack_public_path__ + "static/media/sixinarow-iphone5s-bezel-3-add-events.ab12ba97.ogg";